import tableAppFeedback from './tableAppFeedback';

export default {
  title: 'Feedback',
  attributeName: 'appFeedback',
  getURL: 'appId/appFeedbackPlay',
  createURL: 'appId/appFeedbackPlay',
  updateURL: 'appId/appFeedbackPlay',
  removeURL: 'appId/appFeedbackPlay',
  sessionParams: ['appId'],
  noArea: true,
  removeNameField:'name',
  removeText:'You are about to remove the Feedback with name ##name##.',
  tableConfig: tableAppFeedback,
  sessionWebsocketParams: ['appId'],
  websocketEventChanel: 'appFeedback-appId',
  websocketItem: 'appFeedback',
  autoUpdate: true,
};
